import { useNavigate } from "react-router-dom";
import { ShieldOff, CreditCard, LogOut } from "lucide-react";
import { useAuthStore } from "@/store/authStore";
import { logout as apiLogout } from "@/api/auth";

export default function SuspendedWall() {
  const navigate = useNavigate();
  const { tenant, refreshToken, logout } = useAuthStore();

  async function handleLogout() {
    try {
      if (refreshToken) await apiLogout(refreshToken);
    } catch (_) {}
    logout();
    navigate("/login");
  }

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center px-6 bg-ds-warm">
      <div className="flex h-20 w-20 items-center justify-center rounded-full mb-6 bg-destructive/10">
        <ShieldOff className="h-10 w-10 text-destructive" />
      </div>

      <h1 className="text-2xl font-bold text-center text-ds-house" style={{ letterSpacing: "-0.01em" }}>
        Account Suspended
      </h1>
      <p className="mt-2 text-center text-sm text-muted-foreground max-w-sm">
        <span className="font-semibold text-foreground">{tenant?.name}</span>{" "}
        has been suspended due to an expired subscription. Renew now to restore full access.
      </p>

      <div className="mt-8 flex flex-col sm:flex-row gap-3 w-full max-w-xs">
        <button
          onClick={() => navigate("/subscription")}
          className="flex flex-1 items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold text-white shadow-ds transition-all active:scale-95 bg-ds-accent hover:bg-ds-green"
        >
          <CreditCard className="h-4 w-4" />
          Renew Subscription
        </button>

        <button
          onClick={handleLogout}
          className="flex flex-1 items-center justify-center gap-2 rounded-full border border-ds-ceramic px-5 py-3 text-sm font-medium text-foreground transition-colors hover:bg-panel-2"
        >
          <LogOut className="h-4 w-4" />
          Log Out
        </button>
      </div>

      <p className="mt-6 text-xs text-muted-foreground text-center">
        Need help?{" "}
        <a href="mailto:support@step.uz" className="underline hover:text-muted-foreground text-ds-green">
          support@step.uz
        </a>
      </p>
    </div>
  );
}
